import { BackendModel, BackendService } from '../../core/backend.service';

export class TipoImpresion extends BackendModel {

  static path = '/productos/tipos-impresiones/';

  id: number;
  description: string;
  nombre: string;

  constructor(protected backendService: BackendService, model?: TipoImpresion) {
    super(backendService, model);
  }
}



// WEBPACK FOOTER //
// ./src/app/productos/tipo-impresion/tipo-impresion.model.ts